<template>
  <div class="licence-analytic" :class="[editMode ? 'editMode' : '']">
    <input :id="uniq" maxlength="30" type='text' v-on:keyup.enter="editMode && edit(true)"
           v-on:keyup.esc="editMode && edit(false)" :value="object.analyticCode" :readonly="editMode === false"
           :class="[editMode ? 'edit-mode' : 'read-only']"/>
    <i @click='edit(true)' class='fa fa-fw fa-2x' :class="[editMode ? 'fa-check' : 'fa-pencil-square']"/>
  </div>
</template>

<script>
import axios from "axios";
import API from '@/services/API.js';

export default {
  name: 'AnalyticsRenderer',
  props: ['object'],
  data: () => ({
    editMode: false,
    uniq: null
  }),
  computed: {},
  mounted() {
    this.uniq = this._uid;
  },
  methods: {
    edit: function (save) {
      if (this.editMode) {
        if (save) {
          let value = document.getElementById(this.uniq).value;
          if (value !== this.object.analyticCode) {
            this.object.analyticCode = value;
            var objToEdit = {
              name: this.object.name,
              groupId: this.object.groupId,
              profileId: this.object.profileId,
              analyticCode: this.object.analyticCode == null ? "" : this.object.analyticCode
            };
            axios.put(API.route(API.endpoints.datis.edit, {id: this.object.id}), objToEdit)
              .then(response => {
                window.Vfc.$refs.messages.sendMessage('success', Utils.t('global.dataSaved'));
                if (response.status === 202) {
                  window.Vfc.$refs.messages.sendMessage('error', Utils.t('device.noNotificationError'));
                }
                //window.V._router.push('/devices/list');
              })
              .catch(error => {
                if (error.response != null) {
                  var errorBag = this.$validator.errorBag;
                  if (error.response.status === 422) {
                    FormUtils.handleErrors(errorBag, error.response.data.message)
                  }
                  FormUtils.showAllErrors(this);
                } else {
                }
                window.Vfc.$refs.loading.hide();
              })
          }
        }
        this.editMode = false;
      } else {
        this.editMode = true;
      }
    }
  }
}
</script>

<style scoped>

</style>
